import React from 'react';
import classnames from 'classnames';

const HoursColumnValue = ({ value, className }) =>
  !value && value !== 0 ? null : (
    <span
      className={classnames(
        'amount',
        { 'text-muted': !value, 'text-danger': value < 0 },
        className,
      )}
    >
      {value.toTime()}
    </span>
  );
export default HoursColumnValue;
